import { extractApiErrorCode } from '@/shared/lib';
import type { DocumentLinkContainer } from '../api/documents.api';
import { DOCUMENT_ALREADY_LINKED_TO_FOLDER_CODE } from '../config/documentLink';
import type { DirectoryTreeNode } from './types';
import { extractNumericId } from './directoryTree.utils';

export function isDocumentAlreadyLinkedError(error: unknown): boolean {
  return extractApiErrorCode(error) === DOCUMENT_ALREADY_LINKED_TO_FOLDER_CODE;
}

export function resolveDocumentLinkContainer(
  node: DirectoryTreeNode | null | undefined
): DocumentLinkContainer | null {
  if (!node) {
    return null;
  }

  switch (node.kind) {
    case 'module': {
      const id = extractNumericId(node.id, 'module-');
      return id === undefined ? null : { type: 'module', id };
    }
    case 'folder': {
      const id = extractNumericId(node.id, 'folder-');
      return id === undefined ? null : { type: 'folder', id };
    }
    default:
      return null;
  }
}

export function buildEligibleDocumentsSearchUrl(
  node: DirectoryTreeNode | null | undefined
): string | null {
  const container = resolveDocumentLinkContainer(node);

  if (!container) {
    return null;
  }

  return container.type === 'module'
    ? `/modules/${container.id}/eligible-documents`
    : `/folders/${container.id}/eligible-documents`;
}
